export default class AccountModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }

  parse(response) {
    // This model can end up being used as a result from ID
    // or the Core Mobile API. The properties are the same 
    // but the mobile API has a top-level "data" property.
    if (response.data) {
      return response.data; 
    } else {
      return response; 
    }
  }
}
